import React from 'react';
import PropTypes from 'prop-types';

import CustomSelect from '../../../components/Select/CustomSelect';
import { articleStatusList } from '../../../constants/articleStatus';
import Card from '../../../components/Card/Card';

const cardBodyClassName = 'px-[30px] pb-[30px]';
const cardContainerClassName = 'flex-none mb-[40px]';

const ArticlesStatus = ({ value, onSelect }) => (
  <Card
    headerTitle="Status"
    showHeader
    styleBodyContainer={cardBodyClassName}
    styleContainer={cardContainerClassName}
    headerBordered={false}
  >
    <CustomSelect
      options={articleStatusList}
      isSearchable={false}
      placeholder="Select status"
      onChange={onSelect}
      value={[value]}
    />
  </Card>
);

ArticlesStatus.propTypes = {
  value: PropTypes.shape({}),
  onSelect: PropTypes.func,
};

ArticlesStatus.defaultProps = {
  onSelect: () => {},
  value: null
};

export default ArticlesStatus;
